<div class="container">
    @if (images) {
    <ngb-carousel>
        <ng-template ngbSlide>
            <div class="picsum-img-wrapper" (click)="goToEvent()">
                <img [src]="images[0]" alt="Banner home festival yes7tickes" />
            </div>
        </ng-template>
        <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[1]" alt="Imagem do banner da home" />
            </div>
        </ng-template>
        <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[2]" alt="Imagem do banner da home" />
            </div>
        </ng-template>
    </ngb-carousel>
    }
</div>